import React from 'react';
import { useNavigate } from 'react-router-dom';

const SubscriptionFailure = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-orange-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 text-center">
        {/* Icono de error */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-gradient-to-br from-red-400 to-red-600 rounded-full flex items-center justify-center">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </div>

        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Pago No Procesado
        </h2>

        <p className="text-gray-600 mb-6">
          No se pudo procesar tu pago. No te preocupes, no se realizó ningún cargo.
        </p>

        <div className="bg-red-50 border border-red-200 rounded-2xl p-4 mb-6">
          <p className="text-sm text-gray-700">
            <strong className="text-red-700">Posibles causas:</strong><br/>
            • Fondos insuficientes<br/>
            • Datos incorrectos<br/>
            • Cancelaste el pago<br/>
            • Problema con Mercado Pago
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/?section=pricing')}
            className="w-full bg-gradient-to-r from-blue-500 via-cyan-500 to-green-500 text-white py-4 rounded-2xl font-bold text-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
          >
            Intentar Nuevamente
          </button>
          
          <button
            onClick={() => navigate('/dashboard/profesional')}
            className="w-full text-gray-600 hover:text-gray-900 py-3 rounded-xl font-medium transition-colors"
          >
            Volver al Dashboard
          </button>
        </div>

        <p className="text-center text-xs text-gray-500 mt-6">
          ¿Problemas? Escribinos por{' '}
          <a 
            href="https://wa.me/5493794080538?text=Hola,%20tuve%20un%20problema%20con%20el%20pago"
            target="_blank"
            rel="noopener noreferrer"
            className="text-green-600 hover:text-green-700 font-medium"
          >
            WhatsApp
          </a>
        </p>
      </div>
    </div>
  );
};

export default SubscriptionFailure;